export default __webpack_public_path__ + "static/media/sticker_med_2.aa0f1985.png";